export default function getById (array, id) {
  let obj = null
  array.forEach(item => {
    if (item && id === item.id) obj = item
  })
  return obj
}


// WEBPACK FOOTER //
// ./src/helpers/users/licenses/getById.js